

import { dispatchAdmision } from '../Context/store';

//action types
import { navigationType } from '../Context/actionType';

export const useActionDispatch = () => {

   const admisionDispatch = dispatchAdmision();
   
   /**
    * 
    * @param {number} page 
    */
   const handleNavigationPage = (page) => {
      admisionDispatch(navigationType(page))
   } 

  return { handleNavigationPage }
}
